import * as React from "react";
import * as _ from "lodash";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import i18n from "i18n";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import {
  GridListTile,
  GridListTileBar,
  Typography,
  Input,
  withStyles,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import {
  Image,
  Group,
  Public,
  MoreVert,
  Check,
  Person,
} from "@material-ui/icons";
import { ProfileService } from "modules/profile/ProfileService";
import { RateLibrary } from "modules/rateLibrary/models/RateLibrary";
import { RateLibraryService } from "modules/rateLibrary/RateLibraryService";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import { ExceptionStore } from "common/exception/ExceptionStore";
import { LoginStore } from "modules/login/LoginStore";
import { LoginService } from "modules/login/LoginService";
import CardGridImage from "./CardGridImage";
import * as libLocations from "modules/rateLibrary/assets/rateLibraryLocation";

import { Button, Avatar, Tooltip } from "@material-ui/core";
import RateLibraryAvatar from "./RateLibraryAvatar";

const styles = (theme) => ({
  gridList: {
    backgroundColor: "#ffffff",
    transition: "all 0.3s ease-in",
    margin: 12.5,
    height: 250,
    width: 250,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
    "&:hover > div > #layer": {
      opacity: 1,
    },
    "&:hover > div > :last-child > :last-child > svg": {
      opacity: 1,
    },
    "&:hover ~ #rateLibName": {
      borderBottom: "1px dotted",
    },
    "&:hover > div > div > #btnFollow": {
      opacity: 1,
    },
  },
  avatar: {
    margin: 10,
    width: 34,
    height: 34,
  },
  tile: {
    width: "100%",
    height: "65px",
    backgroundColor: "#ffffff",
    "& > div:first-child": {
      marginRight: 55,
    },
  },
  tileFoot: {
    width: "100%",
    height: "90px",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "flex-start",
  },
  cardMenu: {
    fontSize: 14,
    "& ul": {
      padding: 0,
    },
    "& li": {
      fontSize: 14,
    },
  },
  tileLoad: {
    width: "100%",
    height: "65px",
    backgroundColor: "#ffffff",
  },
  tileTitleSpan: {
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000000",
    fontSize: "14px",
    cursor: "pointer",
    display: "inline-block",
    width: "135px",
    "&:hover": {
      borderBottom: "1px dotted",
    },
  },
  publicTileTitleSpan: {
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000000",
    fontSize: "14px",
    display: "inline-block",
  },
  inputName: {
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000000",
    fontSize: "14px",
    padding: "0px",
    "&::selection": {
      background: "#ABC200",
    },
    "&::after": {
      borderBottom: "1px solid !important",
    },
  },
  tileSubtitle: {
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#7f7f7f",
    fontSize: "11px",
  },
  tileSubtitleLoad: {
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "rgba(0, 0, 0, 0.34)",
    fontSize: "11px",
  },
  starIcon: {
    opacity: 0,
    color: theme.palette.primary.light,
    marginRight: "15px",
    transition: "opacity 300ms ease-in",
  },
  deleteIcon: {
    top: -56,
    right: 8,
    color: "#919191",
    zIndex: 2,
    /* ,
    transition: 'color 200ms ease-in',
    '&:hover': {
      color: '#ffffff'
    } */
  },
  imageIcon: {
    top: 15,
    left: 10,
    color: "#919191",
    zIndex: 2,
    transition: "color 200ms ease-in",
    "&:hover": {
      color: "#ffffff",
    },
  },
  layerOptions: {
    opacity: 0,
    top: 0,
    left: 0,
    width: "100%",
    height: "125px",
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 1,
    cursor: "pointer",
    transition: "opacity 300ms ease-in",
    textDecoration: "none",
    marginTop: 65,
  },
  viewProject: {
    border: "1px solid",
    borderColor: "#919191",
    padding: "5px 10px",
    color: "#919191",
    width: "fit-content",
    margin: "0 auto",
    marginTop: "60px",
    height: "24px",
    borderRadius: "12px",
    fontSize: "11px",
    fontFamily: "Raleway",
    fontWeight: 700,
    transition: "all 200ms ease-in",
    "&:hover": {
      borderColor: "#ffffff",
      color: "#ffffff",
    },
    letterSpacing: "2px",
  },
  locations: {
    fontSize: 12,
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "pointer",
    "&:hover": {
      borderBottom: "1px dotted",
    },
  },
  sharing: {
    fontSize: 10,
    marginTop: "10px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "pointer",
    "&:hover": {
      borderBottom: "1px dotted",
    },
  },
  publicLocations: {
    fontSize: 12,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  publicSharing: {
    fontSize: 10,
    marginTop: "10px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  loadContainer: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "0 auto",
    position: "relative" as any,
  },
  button: {
    margin: theme.spacing.unit,
    marginTop: "57px",
    alignSelf: "flex-end",
    width: "116px",
    color: "#C4C4C4",
    fontSize: "11px",
    letterSpacing: "1px",
    transition: "all 0.3s ease-in",
    opacity: 0,
    "&:hover": {
      color: "#000000",
    },
    borderRadius: "4px",
  },
  buttonError: {
    display: "block",
    textAlign: "center" as any,
    margin: "0 auto",
    letterSpacing: "1px",
  },
  buttonFollowing: {
    color: "#000000",
    border: "1px solid #D8E389",
    margin: theme.spacing.unit,
    marginTop: "57px",
    alignSelf: "flex-end",
    width: "116px",
    fontSize: "11px",
    letterSpacing: "1px",
    transition: "all 0.3s ease-in",
    borderRadius: "4px",
  },
});

type IProps = {
  key: string;
  rateLibrary: FirebaseDocument<RateLibrary>;
  classes: any;
  selected: Boolean;
};

@observer
class CardGrid extends React.Component<IProps> {
  state = {
    editName: false,
    newName: "",
    disabledInput: false,
    inputName: null as any,
    anchorEl: null,
    displayName: "",
    teste: ProfileService.getUserId(),
    userList: [],
  };

  componentDidMount() {
    this.getOwnerName();
  }

  componentDidUpdate() {
    this.getOwnerName();
  }

  componentDidCatch(error, info) {
    console.log("info/error: ", info, error);
    ExceptionStore.OpenException(info);
  }

  handleNameChange = (e) => (this.state.newName = e.target.value);
  handleClickName = () =>
    this.setState(
      { newName: this.props.rateLibrary.data.name, editName: true },
      () => {
        this.state.inputName.focus();
        this.state.inputName.select();
      }
    );
  saveNewName = async () => {
    if (this.state.newName !== this.props.rateLibrary.data.name) {
      await RateLibraryService.changeRateLibraryName(
        this.props.rateLibrary,
        this.state.newName
      );
      this.props.rateLibrary.data.name = this.state.newName;
    }
    this.setState({ disabledInput: false, editName: false });
  };

  handleDeleteRateLib = (lib) => (e) => {
    RateLibraryStore.deleteRateLibrary = lib;
    this.setState({ anchorEl: null });
    this.killEvent(e);
  };

  handleConfirm = (lib) => (e) => {
    RateLibraryStore.deleteRateLibrary = lib;
    let canDelete = true;
    for (let index = 0; index < lib.data.files.length; index++) {
      const element = lib.data.files[index];
      if (element.status == "processed") {
        canDelete = false;
      }
    }
    if (canDelete) {
      RateLibraryService.DeleteRateLibrary(RateLibraryStore.deleteRateLibrary);
    } else {
      RateLibraryService.ChangeRateLibraryStatus(
        RateLibraryStore.deleteRateLibrary
      );
    }
    RateLibraryStore.deleteRateLibrary = false;
  };

  handleResetLib = (lib) => (e) => {
    let modifiedFiles = lib.data.files.map(({ ...item }) => {
      if (item.status === "error") item.status = "pending";
      return item;
    });

    RateLibraryService.restartProcesses(lib, modifiedFiles);
  };
  handleImportFile = (event) => {
    (this.refs.inputRateLibFile as any).dispatchEvent(new MouseEvent("click"));
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  handleOpenSelection = (lib) => (e) => {
    RateLibraryStore.updateImageRateLibrary = lib;
    RateLibraryStore.buttonFileUpload.dispatchEvent(new MouseEvent("click"));
    this.killEvent(e);
  };

  handleClickOptCard = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.killEvent(event);
  };
  handleCloseOptCard = (event) => {
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  handleOpenLocationDialog = (lib) => (e) => {
    let location: any = [];
    for (let index = 0; index < lib.data.location.length; index++) {
      for (
        let select = 0;
        select < libLocations.availableLocations.length;
        select++
      ) {
        if (
          lib.data.location[index] ==
          libLocations.availableLocations[select].value
        ) {
          location.push(libLocations.availableLocations[select]);
        }
      }
    }
    RateLibraryStore.editLocation = location;

    RateLibraryStore.rateLibraryLocationRef = lib;
    RateLibraryStore.openUpdateLocationDialog = true;
  };

  handleOpenShareLibraryDialog = (lib) => async (e) => {
    RateLibraryStore.openShareLibrary = lib;
    RateLibraryStore.openShareLibraryDialog = true;
    this.setState({ anchorEl: null });
    this.killEvent(e);
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  getLocations = (locationArray) => {
    let locations = "";
    let availableLocations = libLocations.availableLocations;
    if (locationArray != null && locationArray != undefined)
      locationArray.forEach((location) => {
        let locationName = _.find(availableLocations, function (loc) {
          return loc.value == location;
        });
        if (locationName != undefined) {
          if (locations == "") {
            locations = locationName.label;
          } else {
            locations = locations + ", " + locationName.label;
          }
        }
      });
    return locations;
  };

  userList(lib) {
    if (lib.data.users[ProfileService.getUserId()] == 0) {
      if (lib.data.sharedUsers && lib.data.sharedUsers.length > 0) {
        return lib.data.sharedUsers
          .map(function (u) {
            return u.displayName;
          })
          .join(", ");
      } else {
        return i18n.rateLibraries.shareLibraries;
      }
    } else {
      i18n.rateLibraries.RateLibrarySharedWithMe;
    }
  }

  getTimeDiffByMonth = (months, date1, date2) => {
    let days = date1.getDate() - date2.getDate();
    if (months > 0 && days <= 0) {
      months -= 1;
      days += new Date(date2.getFullYear(), date2.getMonth() + 1, 0).getDate();
    }
    if (months === 0) {
      if (days >= 7) {
        let weeks = Math.trunc(days / 7);
        return `${
          weeks === 1 ? `1 ${i18n.date.week}` : `${weeks} ${i18n.date.weeks}`
        } ${i18n.date.ago}`;
      } else if (days !== 0)
        return `${
          days === 1 ? `1 ${i18n.date.day}` : `${days} ${i18n.date.days}`
        } ${i18n.date.ago}`;
      else return i18n.date.today;
    } else
      return `${
        months === 1 ? `1 ${i18n.date.month}` : `${months} ${i18n.date.months}`
      } ${i18n.date.ago}`;
  };
  getTimeDiff = (date1: Date, date2: Date) => {
    let years = date1.getFullYear() - date2.getFullYear();
    let months = date1.getMonth() - date2.getMonth();
    if (years > 0 && months <= 0) {
      years -= 1;
      months += 12;
    }
    if (years === 0) return this.getTimeDiffByMonth(months, date1, date2);
    else {
      let days = date1.getDate() - date2.getDate();
      if (months > 0 && days <= 0) months -= 1;
      return (
        (years === 1 ? `1 ${i18n.date.year}` : `${years} ${i18n.date.years}`) +
        (months > 0
          ? months === 1
            ? ` e 1 ${i18n.date.month}`
            : ` e ${months} ${i18n.date.months}`
          : "") +
        ` ${i18n.date.ago}`
      );
    }
  };

  getFilePropertyByStatus = (files, status, property) => {
    let file = files.find(function (file) {
      return file.status == status;
    });
    return file != undefined ? file[property] : "";
  };

  getOwnerName = async () => {
    let {
        props: { rateLibrary },
        state: { displayName },
      } = this,
      users = rateLibrary.data.users,
      uid = Object.keys(users).find((key) => users[key] === 0),
      newDisplayName;
    if (uid) {
      if (LoginStore.userAuth && uid === LoginStore.userAuth.uid)
        newDisplayName = LoginStore.userAuth.displayName;
      else newDisplayName = await LoginService.getUserName(uid);
      if (newDisplayName !== displayName)
        this.setState({ displayName: newDisplayName });
    } else if (displayName !== "") this.setState({ displayName: "" });
  };

  renderOwnerName = () =>
    RateLibraryStore.currentTab == 0 ? (
      <div>
        {i18n.rateLibraries.cardProcessing.by + " " + this.state.displayName}{" "}
        <Person
          style={{
            fontSize: 14,
            position: "relative",
            top: 3,
            left: 3,
            color: "#BABABA",
          }}
        />
      </div>
    ) : (
      <div>
        {i18n.rateLibraries.cardProcessing.by + " " + this.state.displayName}{" "}
        <Public
          style={{
            fontSize: 14,
            position: "relative",
            top: 3,
            left: 3,
            color: "#BABABA",
          }}
        />
      </div>
    );

  fileAddHandler = (lib, libId) => async (event) => {
    let file = event.target.files[0];
    if (file.name.includes("xlsx") || file.name.includes("xls")) {
      RateLibraryService.AddFileToLibrary(file, lib, libId);
      this.handleCloseOptCard(event);
    }
  };

  followDatabase = (lib) => async (e) => {
    RateLibraryService.updateFollowerDatabase(lib);
  };

  render() {
    const { classes } = this.props,
      { id } = this.props.rateLibrary,
      { editName, disabledInput, userList } = this.state;
    const open = Boolean(this.state.anchorEl);
    let lib = this.props.rateLibrary;

    return (
      <GridListTile
        key={lib.id}
        className={classes.gridList}
        style={{ position: "relative", width: "295px", height: "295px" }}
      >
        <GridListTileBar
          className={classes.tile}
          classes={{
            subtitle: classes.tileSubtitle,
          }}
          title={
            editName ? (
              <label
                ref={(node: any) =>
                  (this.state.inputName =
                    node && node.childNodes[0]
                      ? node.childNodes[0].childNodes[0]
                      : null)
                }
              >
                <Input
                  classes={{ input: classes.inputName }}
                  defaultValue={this.state.newName}
                  placeholder={i18n.rateLibraries.name}
                  onChange={this.handleNameChange}
                  onBlur={this.saveNewName}
                  disabled={disabledInput}
                />
              </label>
            ) : (
              <Typography
                id="rateLibName"
                component="span"
                className={
                  RateLibraryStore.currentTab == 0
                    ? classes.tileTitleSpan
                    : classes.publicTileTitleSpan
                }
                onClick={
                  RateLibraryStore.currentTab == 0
                    ? this.handleClickName
                    : () => {}
                }
              >
                {lib.data.name}
              </Typography>
            )
          }
          subtitle={this.renderOwnerName()}
          actionIcon={<RateLibraryAvatar lib={lib.data} />}
          titlePosition="top"
          actionPosition="left"
        />
        {lib.data.status == "processed" && (
          <Link
            to={`/menu/rateLibraries/${id}`}
            id="layer"
            className={classes.layerOptions}
            style={{ position: "absolute" }}
          >
            <Image
              style={{
                position: "absolute",
                display: RateLibraryStore.currentTab == 0 ? "inline" : "none",
              }}
              fontSize="small"
              className={classes.imageIcon}
              onClick={this.handleOpenSelection(lib)}
            />
            {lib.data.users[ProfileService.getUserId()] == 0 ? (
              <>
                <IconButton
                  aria-label="More"
                  aria-owns={open ? "long-menu" : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClickOptCard}
                  style={{
                    position: "absolute",
                    display:
                      RateLibraryStore.currentTab == 0 ? "inline" : "none",
                  }}
                  //              fontSize="small"
                  className={classes.deleteIcon}
                >
                  <MoreVert />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={this.state.anchorEl}
                  open={open}
                  onClose={this.handleCloseOptCard}
                  PaperProps={{
                    style: {
                      width: 160,
                    },
                  }}
                  className={classes.cardMenu}
                >
                  <MenuItem
                    key={0}
                    selected={false}
                    onClick={this.handleImportFile}
                    style={{ fontSize: 14 }}
                  >
                    {i18n.rateLibraries.card.import}
                  </MenuItem>
                  <MenuItem
                    key={2}
                    selected={false}
                    onClick={this.handleDeleteRateLib(lib)}
                    style={{ fontSize: 14 }}
                  >
                    {i18n.delete}
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <></>
            )}
            <Typography className={classes.viewProject} component="span">
              {i18n.rateLibraries.view}
            </Typography>

            <input
              ref="inputRateLibFile"
              style={{ display: "none" }}
              accept=".xls, .xlsx"
              className={classes.input}
              id="contained-button-file"
              type="file"
              onChange={this.fileAddHandler(lib.data, lib.id)}
            />
          </Link>
        )}
        {lib.data.status == "processed" && (
          <div
            style={{ marginTop: 65, display: "flex", flexDirection: "column" }}
          >
            <CardGridImage imageUrl={(lib.data as any).image} />

            <GridListTileBar
              className={classes.tileFoot}
              classes={{
                subtitle: classes.tileSubtitle,
              }}
              title={
                <>
                  <Tooltip title={this.getLocations(lib.data.location)}>
                    <Typography
                      component="span"
                      className={
                        RateLibraryStore.currentTab == 0
                          ? classes.locations
                          : classes.publicLocations
                      }
                      onClick={
                        RateLibraryStore.currentTab == 0
                          ? this.handleOpenLocationDialog(lib)
                          : () => {}
                      }
                    >
                      {this.getLocations(lib.data.location)}
                    </Typography>
                  </Tooltip>
                  <Tooltip title={lib.data.description}>
                    <Typography
                      component="span"
                      className={classes.publicLocations}
                      style={{
                        fontSize: "11px",
                        lineHeight: "13px",
                        margin: "7px 0px 0px",
                      }}
                    >
                      {lib.data.description}
                    </Typography>
                  </Tooltip>
                </>
              }
              subtitle={
                <Typography>
                  {RateLibraryStore.currentTab == 0 ? (
                    <div>
                      {RateLibraryStore.currentTab == 0 &&
                      lib.data.users[ProfileService.getUserId()] == 0 ? (
                        <Tooltip title={this.userList(lib)}>
                          <div
                            onClick={this.handleOpenShareLibraryDialog(lib)}
                            style={{ cursor: "pointer" }}
                            className={
                              RateLibraryStore.currentTab == 0
                                ? classes.sharing
                                : classes.publicSharing
                            }
                          >
                            <Group
                              style={{
                                fontSize: 14,
                                position: "relative",
                                top: 3,
                                marginRight: "5px",
                                color: "#BABABA",
                              }}
                            />
                            {this.userList(lib)}
                          </div>
                        </Tooltip>
                      ) : (
                        <div
                          className={
                            RateLibraryStore.currentTab == 0
                              ? classes.sharing
                              : classes.publicSharing
                          }
                        >
                          <Group
                            style={{
                              fontSize: 14,
                              position: "relative",
                              top: 3,
                              marginRight: "5px",
                              color: "#BABABA",
                            }}
                          />
                          {i18n.rateLibraries.RateLibrarySharedWithMe}
                        </div>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Typography>
              }
            />
            {lib.data.users[ProfileService.getUserId()] !== 0 &&
            RateLibraryStore.currentTab != 0 ? (
              <Button
                id="btnFollow"
                onClick={this.followDatabase(lib)}
                variant="outlined"
                className={
                  lib.data.users[ProfileService.getUserId()] === 2
                    ? classes.buttonFollowing
                    : classes.button
                }
              >
                {lib.data.users[ProfileService.getUserId()] === 2
                  ? i18n.following
                  : i18n.follow}
              </Button>
            ) : (
              false
            )}
          </div>
        )}

        {(lib.data.status == "pending" ||
          lib.data.status == "sortingData" ||
          (lib.data.status == "uploading" &&
            (Object.keys(RateLibraryStore.progressStatusUpload).length == 0 ||
              !(lib.id in RateLibraryStore.progressStatusUpload)))) && (
          <div className={classes.loadContainer}>
            <div className={classes.wrapper}>
              <div
                style={{ width: "100%", marginTop: 80, textAlign: "center" }}
              >
                <CircularProgress size={90} style={{ color: "#ABC200" }} />
              </div>
            </div>
            <GridListTileBar
              className={classes.tileLoad}
              classes={{
                subtitle: classes.tileSubtitleLoad,
              }}
              style={{ textAlign: "center" }}
              title={
                <Typography
                  component="span"
                  className={classes.publicLocations}
                >
                  {lib.data.status == ("pending" as any)
                    ? i18n.rateLibraries.cardProcessing.waiting
                    : i18n.rateLibraries.cardProcessing.importing}
                </Typography>
              }
              subtitle={this.getFilePropertyByStatus(
                lib.data.files,
                lib.data.status,
                "fileName"
              ).replace(lib.id, "")}
            />
          </div>
        )}
        {Object.keys(RateLibraryStore.progressStatusUpload).length > 0 &&
          lib.id in RateLibraryStore.progressStatusUpload && (
            <div className={classes.loadContainer}>
              <div className={classes.wrapper}>
                <div
                  style={{ width: "100%", marginTop: 80, textAlign: "center" }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "116px",
                      left: "50%",
                      marginLeft: "-14px",
                      color: "#ABC200",
                    }}
                  >
                    {RateLibraryStore.progressStatusUpload[lib.id]}%
                  </span>
                  <CircularProgress
                    size={90}
                    variant="determinate"
                    value={RateLibraryStore.progressStatusUpload[lib.id]}
                    style={{ color: "#ABC200" }}
                  />
                </div>
              </div>
              <GridListTileBar
                className={classes.tileLoad}
                classes={{
                  subtitle: classes.tileSubtitleLoad,
                }}
                style={{ textAlign: "center" }}
                title={
                  <Typography
                    component="span"
                    className={classes.publicLocations}
                  >
                    {i18n.rateLibraries.cardProcessing.importing}
                  </Typography>
                }
                subtitle={
                  RateLibraryStore.progressStatusUploadFile[lib.id + "file"] +
                  ".xls"
                }
              />
            </div>
          )}

        {lib.data.status == "processing" && (
          <div className={classes.loadContainer}>
            <div className={classes.wrapper}>
              <div
                style={{ width: "100%", marginTop: 80, textAlign: "center" }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "116px",
                    left: "50%",
                    marginLeft: "-14px",
                    color: "#ABC200",
                  }}
                >
                  {this.getFilePropertyByStatus(
                    lib.data.files,
                    "processing",
                    "progress"
                  )}
                  %
                </span>
                <CircularProgress size={90} style={{ color: "#ABC200" }} />
              </div>
            </div>
            <GridListTileBar
              className={classes.tileLoad}
              classes={{
                subtitle: classes.tileSubtitleLoad,
              }}
              style={{ textAlign: "center" }}
              title={
                <Typography
                  component="span"
                  className={classes.publicLocations}
                >
                  {i18n.rateLibraries.cardProcessing.importing}
                </Typography>
              }
              subtitle={this.getFilePropertyByStatus(
                lib.data.files,
                "processing",
                "fileName"
              ).replace(lib.id, "")}
            />
          </div>
        )}
        {lib.data.status == "error" && (
          <div className={classes.loadContainer}>
            <div className={classes.wrapper}>
              <div
                style={{ width: "100%", marginTop: 80, textAlign: "center" }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "116px",
                    left: "50%",
                    marginLeft: "-20px",
                    color: "#AC4D4D",
                    fontSize: "14px",
                  }}
                >
                  {i18n.rateLibraries.error.message}
                </span>
                <CircularProgress
                  variant="static"
                  value={100}
                  size={90}
                  style={{ color: "#AC4D4D" }}
                />
              </div>
            </div>
            <GridListTileBar
              className={classes.tileLoad}
              classes={{
                subtitle: classes.tileSubtitleLoad,
              }}
              style={{ textAlign: "center", marginBottom: "30px" }}
              title={
                <div>
                  {lib.data.typeError != undefined ? (
                    <Typography
                      component="span"
                      className={classes.publicLocations}
                      style={{
                        fontSize: "14px",
                        color: "#AC4D4D",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {lib.data.typeError == "multipleTabs"
                        ? i18n.rateLibraries.error.multipleTabs
                        : ""}
                    </Typography>
                  ) : (
                    <Typography
                      component="span"
                      className={classes.publicLocations}
                      style={{ fontSize: "14px", color: "#AC4D4D" }}
                    >
                      {i18n.rateLibraries.error.title}
                    </Typography>
                  )}

                  {lib.data.typeError == "multipleTabs" ? (
                    ""
                  ) : (
                    <Button
                      onClick={this.handleResetLib(lib)}
                      color="primary"
                      className={classes.buttonError}
                      style={{ marginTop: "15px", fontSize: "12px" }}
                    >
                      {i18n.rateLibraries.error.tryAgain}
                    </Button>
                  )}

                  <Button
                    onClick={this.handleConfirm(lib)}
                    color="secondary"
                    className={classes.buttonError}
                    style={{ fontSize: "10px" }}
                  >
                    {i18n.rateLibraries.error.cancel}
                  </Button>
                </div>
              }
              subtitle={this.getFilePropertyByStatus(
                lib.data.files,
                "processing",
                "fileName"
              ).replace(lib.id, "")}
            />
          </div>
        )}
      </GridListTile>
    );
  }
}

export default withStyles(styles)(CardGrid);



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/CardGrid.tsx